import React, { useContext, useState } from "react"

import ReactDOM from "react-dom"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"

import { updateTeeupArchiveStatus } from "@actions/teeupActions"
import { ButtonEl } from "@components/common"
import { teeupStatusKeys } from "@config/enums"
import { BUTTON_VARIANTS } from "@constants/button"
import { NewTeeupPageContext } from "@contexts/NewTeeupPageContext"
import { selectActiveTeeupOrganizers } from "@selectors/activeTeeup"
import { selectTeeupActivePeople } from "@selectors/teeups"
import { selectUserInfo } from "@selectors/user"
import { reloadPage } from "@utils/reloadPage"
import { useSnackbarStore } from "stores/snackbarStore"

import {
  dropoutTeeup,
  updateTeeupStatus,
} from "../../../middlewares/backendMiddleware"
import ConfirmAction from "../../../pages/TeeUpPage/TeeUpPageLeftSection/TeeupSettings/ConfirmAction"

import { Wrapper } from "./buttonsPanelStyles"

const ACTIONS_INDEXES = {
  LEAVE: 1,
  CANCEL: 2,
}

export const ButtonsPanel = () => {
  const { teeup, isTeeupOrganiser } = useContext(NewTeeupPageContext)
  const user = useSelector(selectUserInfo)
  const [teeUpActionType, setTeeUpActionType] = useState(0)
  const [isConfirmWindowOpen, setIsConfirmWindowOpen] = useState(false)
  const history = useHistory()
  const organizers = useSelector(selectActiveTeeupOrganizers)
  const setSnackbarConfig = useSnackbarStore(state => state.setSnackbarConfig)

  const handleTeeUpActions = async () => {
    if (teeUpActionType === 1) {
      // WB4 (Wave 3): this is the LIVE "Leave Teeup" button (the old TeeupSettings/
      // TeeupSettingsLeftSide copy of this same flow is unreachable dead code -- the settings
      // gear on the teeup detail page opens NewTeeupSettings, not the old component). Same
      // confirmed-write-before-navigate contract as the other call site: only leave the page /
      // reload once the DELETE actually succeeds.
      try {
        await dropoutTeeup({ teeup, userId: user.id })
        document.title = "CooWe Coordinator"
        history.push("/inbox")
        reloadPage()
      } catch (e) {
        setSnackbarConfig({
          message: e?.message || "Could not leave the TeeUp. Please try again.",
          open: true,
        })
      }
    } else {
      updateTeeupArchiveStatus(teeup.id)
      updateTeeupStatus(user.id, teeupStatusKeys.cancelled)
    }
  }

  const handleActionClick = index => {
    // WB4 (Wave 3): this "need 2 organizers" guard was blocking EVERY participant from leaving
    // (not just organizers) whenever a teeup had a single organizer -- confirmed live: a plain
    // participant (maya, non-organizer) got "You need to have at least 2 organizers to leave the
    // TeeUp" and could not leave at all. The constraint only makes sense for an organizer leaving
    // (so the teeup doesn't end up with zero organizers); a non-organizer participant leaving
    // never changes the organizer count and must always be allowed.
    if (
      index === ACTIONS_INDEXES.LEAVE &&
      isTeeupOrganiser &&
      organizers.length < 2
    ) {
      setSnackbarConfig({
        message: "You need to have at least 2 organizers to leave the TeeUp",
        open: true,
      })
      return
    }
    setTeeUpActionType(index)
    setIsConfirmWindowOpen(true)
  }

  return (
    <>
      {isConfirmWindowOpen &&
        ReactDOM.createPortal(
          <ConfirmAction
            type={teeUpActionType}
            close={() => setIsConfirmWindowOpen(false)}
            onClick={() => handleTeeUpActions()}
          />,
          document.querySelector("#modal-root")
        )}

      <Wrapper>
        {isTeeupOrganiser && (
          <ButtonEl
            fullWidth
            isIconFirst
            iconColor="var(--radicalRed)"
            variant={BUTTON_VARIANTS.TRANSPARENT}
            iconName="trash-2"
            fontSize={18}
            text="Cancel TeeUp"
            onClick={() => handleActionClick(ACTIONS_INDEXES.CANCEL)}
          />
        )}

        <ButtonEl
          fullWidth
          isBlack
          isIconFirst
          variant={BUTTON_VARIANTS.ROUNDED}
          iconName="leave"
          text="Leave Teeup"
          onClick={() => handleActionClick(ACTIONS_INDEXES.LEAVE)}
        />
      </Wrapper>
    </>
  )
}
